import { render, staticRenderFns } from "./Progressbar.vue?vue&type=template&id=386fa134"
import script from "./Progressbar.vue?vue&type=script&lang=js"
export * from "./Progressbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports